import http from '../util/request.js'

export const orderList = (params) =>{
	return http({
		url:'/apistore/order/list',
		data:params,
		method:'get'
	})
}

export const orderDetail = (params) =>{
	return http({
		url:'/apistore/order/detail',
		data:params,
		method:'get'
	})
}
export const updateStaPayment = (orderNo) =>{
	return http({
		url:'/apistore/order/updateStaPayment?orderNo='+orderNo,
		method:'post'
	})
}

export const orderProduct = (params) =>{
	return http({
		url:'/apistore/order/product',
		data:params,
		method:'get'
	})
}


export const refundlist = (params) =>{
	return http({
		url:'/apistore/order/refundlist',
		data:params,
		method:'get'
	})
}
